var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734334727577,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 42424,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.032 125.312a293.973333 293.973333 0 0 1 300.117333 2.474667C755.626667 184.618667 811.178667 286.08 810.666667 395.093333c-2.133333 108.373333-61.738667 210.304-136.234667 289.066667a798.976 798.976 0 0 1-143.274667 120.32A50.090667 50.090667 0 0 1 513.706667 810.666667a34.986667 34.986667 0 0 1-16.64-5.077334 789.973333 789.973333 0 0 1-206.464-194.005333A395.946667 395.946667 0 0 1 213.333333 389.717333l0.213334-11.648c3.84-104.789333 60.586667-200.533333 150.485333-252.757333z m186.666667 174.848a100.096 100.096 0 0 0-110.677334 22.186667 104.746667 104.746667 0 0 0-22.144 112.64 101.461333 101.461333 0 0 0 93.781334 63.872 99.797333 99.797333 0 0 0 71.808-29.952c19.029333-19.328 29.696-45.653333 29.610666-73.045334a103.381333 103.381333 0 0 0-62.378666-95.701333z",
    fill: "currentColor",
    "p-id": 42425
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.666667 896a213.333333 42.666667 0 1 0 426.666666 0 213.333333 42.666667 0 1 0-426.666666 0Z",
    fill: "currentColor",
    opacity: 0.4,
    "p-id": 42426
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c207eba3a6153ff1b3fd98d3761ac5ff.svg";
export { ForwardRef as ReactComponent };